import React, { useState, useEffect, useRef, Fragment } from "react";
import { CanopyControlPanelWrapper, CanopyHeaderWrap } from "./";

import { product } from "../../assets";

//components
import { ProjectManager } from "../ProjectManager";
import { ModuleInputs, InputHeader } from "./";

// assets
import { solIcon, trashCanBlack, copy, singleSlope, inverted, dual_tilt, rectWithOffsetVerts } from "../../assets";
// antd
import { Button, Menu, Dropdown, Input, Collapse, Empty, Radio, Popconfirm, Tooltip, message } from "antd";
import { DownOutlined } from "@ant-design/icons";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { carportActions } from "../Redux/actions/carport.actions";

// inputs for run
import { convert_to_swm_canopy } from "../Sunfig/data/swm_input_sheet";
import * as turf from "@turf/turf";

import { CanopyInputs } from "./CanopyInputs";

const Module_Header = () => {
  return (
    <CanopyHeaderWrap>
      <img src={product} alt="Solar Panel Racking" />
      <p>Module</p>
    </CanopyHeaderWrap>
  );
};

const Canopies_Header = () => {
  return (
    <CanopyHeaderWrap>
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.9141 1.66016V4.78516H0V14.7461H3.90625V17.0898H5.46875V21.1914H3.90625V23.3398H9.17969V21.1914H7.61719V17.0898H9.17969V14.7461H13.0859V11.6211H15.8203V13.9648H17.3828V18.0664H15.8203V20.2148H21.0938V18.0664H19.5312V13.9648H21.0938V11.6211H25V1.66016H11.9141ZM15.625 2.24609H18.1641V6.34766H15.625V2.24609ZM18.9453 11.6211V18.0664H17.9688V11.6211H18.9453ZM3.71094 5.37109H6.25V9.47266H3.71094V5.37109ZM7.03125 14.7461V21.1914H6.05469V14.7461H7.03125ZM3.125 14.1602H0.585938V10.0586H3.125V14.1602ZM3.125 9.47266H0.585938V5.37109H3.125V9.47266ZM3.71094 14.1602V10.0586H6.25V14.1602H3.71094ZM4.49219 16.5039V14.7461H5.46875V16.5039H4.49219ZM8.59375 21.7773V22.7539H4.49219V21.7773H8.59375ZM8.59375 16.5039H7.61719V14.7461H8.59375V16.5039ZM9.375 14.1602H6.83594V10.0586H9.375V14.1602ZM9.375 9.47266H6.83594V5.37109H9.375V9.47266ZM12.5 14.1602H9.96094V10.0586H12.5V14.1602ZM12.5 9.47266H9.96094V5.37109H12.5V9.47266ZM15.0391 11.0352H13.0859V6.93359H15.0391V11.0352ZM15.0391 6.34766H13.0859V4.78516H12.5V2.24609H15.0391V6.34766ZM15.625 11.0352V6.93359H18.1641V11.0352H15.625ZM16.4062 13.3789V11.6211H17.3828V13.3789H16.4062ZM20.5078 18.6523V19.6289H16.4062V18.6523H20.5078ZM20.5078 13.3789H19.5312V11.6211H20.5078V13.3789ZM21.2891 11.0352H18.75V6.93359H21.2891V11.0352ZM21.2891 6.34766H18.75V2.24609H21.2891V6.34766ZM24.4141 11.0352H21.875V6.93359H24.4141V11.0352ZM24.4141 6.34766H21.875V2.24609H24.4141V6.34766Z"
          fill="#333333"
        />
      </svg>
      <p>Canopies</p>
    </CanopyHeaderWrap>
  );
};

const Canopy_Inputs_Header = () => {
  return (
    <CanopyHeaderWrap>
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.41 3.45225C21.9064 3.42437 21.4359 3.77628 21.4359 4.30674V7.58541H13.3698L13.0123 6.83804C13.8398 5.74083 13.4839 4.12022 12.2814 3.46158L12.3069 1.05074C12.3215 -0.341254 10.1772 -0.351605 10.1626 1.02813L10.1372 3.43643C8.92227 4.0691 8.53203 5.68594 9.3353 6.79908L8.93853 7.58541H0.854492C0.38335 7.58541 0 7.96876 0 8.4399V24.1128C0 24.5839 0.38335 24.9672 0.854492 24.9672H22.5622C23.8991 24.9672 24.9877 23.8853 24.9995 22.5511C24.9996 22.5474 25 22.5439 25 22.5401V6.04234C25 4.61417 23.8381 3.45225 22.41 3.45225V3.45225ZM22.1684 4.30674C22.1684 4.18555 22.321 4.16544 22.41 4.18467C23.4343 4.18467 24.2676 5.01798 24.2676 6.04229V20.7995C23.8274 20.368 23.225 20.1016 22.5615 20.1016C22.4662 20.1162 22.1684 20.1432 22.1684 19.9795V4.30674ZM16.2955 15.3983L15.9129 16.4827L11.7063 7.68956C11.9764 7.62657 12.2287 7.51602 12.453 7.36622L16.2955 15.3983ZM9.8832 7.33902C10.1042 7.49346 10.354 7.60958 10.6227 7.67823L6.23154 16.3804L5.87197 15.2882L9.8832 7.33902ZM12.4367 10.9135L9.82456 10.8859L11.1587 8.24195L12.4367 10.9135ZM10.895 1.03589C10.8997 0.588287 11.579 0.607477 11.5744 1.04302L11.5516 3.21119C11.3273 3.17515 11.0972 3.17222 10.8721 3.20289L10.895 1.03589ZM10.1026 4.35733C10.3938 4.07227 10.7972 3.91109 11.2043 3.91456C12.0597 3.92359 12.7482 4.62681 12.7393 5.48218C12.7303 6.33204 12.0361 7.01719 11.1882 7.01719C11.1827 7.01719 11.1771 7.01714 11.1716 7.0171C10.3162 7.00806 9.62773 6.30484 9.63672 5.44947C9.64106 5.03511 9.80654 4.64722 10.1026 4.35733V4.35733ZM22.5622 24.2349H0.854492C0.787158 24.2349 0.732422 24.1801 0.732422 24.1128V8.43995C0.732422 8.37266 0.787158 8.31788 0.854492 8.31788H8.56885L7.28652 10.8591L6.04941 10.8461C5.57881 10.8377 5.56899 11.5734 6.0417 11.5784L6.9189 11.5877L5.19521 15.0036C5.12183 15.1491 5.10947 15.3144 5.1604 15.4692L5.62817 16.89C5.79468 17.3958 6.51255 17.4494 6.75239 16.9741L9.45684 11.6145L12.7889 11.6497L15.3793 17.0646C15.608 17.5426 16.3285 17.5058 16.5055 17.0043L17.0029 15.5943C17.0572 15.4406 17.0483 15.2749 16.9779 15.1278L15.3268 11.6764L16.204 11.6857C16.6746 11.694 16.6844 10.9583 16.2117 10.9533L14.9746 10.9402L13.7201 8.31783H21.4358V19.9796C21.4358 20.6222 22.0158 20.8543 22.5614 20.8341C23.5003 20.8341 24.2644 21.5965 24.2674 22.5348C24.2645 23.4727 23.5007 24.2349 22.5622 24.2349Z"
          fill="#333333"
        />
        <path
          d="M19.1807 18.2251H2.98718C2.65061 18.2251 2.37683 18.4989 2.37683 18.8354V22.1558C2.37683 22.4923 2.65061 22.7661 2.98718 22.7661H19.1808C19.5174 22.7661 19.7911 22.4923 19.7911 22.1558V18.8354C19.7911 18.4989 19.5173 18.2251 19.1807 18.2251ZM19.0587 22.0337H3.10925V18.9575H4.05295V19.6131C4.05295 20.0714 4.78538 20.0923 4.78538 19.6131V18.9575H5.71916V20.1014C5.71916 20.5597 6.45159 20.5806 6.45159 20.1014V18.9575H7.38533V19.6131C7.38533 20.0714 8.11775 20.0923 8.11775 19.6131V18.9575H9.05154V20.1014C9.05154 20.5597 9.78396 20.5806 9.78396 20.1014V18.9575H10.7177V19.6131C10.7177 20.0714 11.4502 20.0923 11.4502 19.6131V18.9575H12.384V20.1014C12.384 20.5597 13.1164 20.5806 13.1164 20.1014V18.9575H14.0502V19.6131C14.0502 20.0714 14.7826 20.0923 14.7826 19.6131V18.9575H15.7163V20.1014C15.7163 20.5597 16.4488 20.5806 16.4488 20.1014V18.9575H17.3825V19.6131C17.3825 20.0714 18.115 20.0923 18.115 19.6131V18.9575H19.0587V22.0337Z"
          fill="#333333"
        />
      </svg>

      <p>Canopy Inputs</p>
    </CanopyHeaderWrap>
  );
};

const Global_Overrides_Header = () => {
  return (
    <CanopyHeaderWrap>
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24.9482 3.67537C24.8274 3.43426 24.5341 3.33665 24.293 3.45735L23.7742 3.71712C23.82 3.56419 23.848 3.45603 23.8502 3.4471C24.0939 2.51199 23.9149 1.71 23.3327 1.12772C22.7316 0.5267 21.8465 0.42045 20.7017 0.811904C19.8171 1.11444 18.7709 1.70858 17.5083 2.62454C16.3445 1.95277 15.067 1.48212 13.732 1.24506C13.0582 1.12553 12.3669 1.06493 11.6772 1.06493C11.1783 1.06493 10.6732 1.0973 10.1759 1.16117C9.90846 1.19554 9.71944 1.44017 9.75382 1.70765C9.78819 1.97518 10.033 2.16439 10.3003 2.12977C10.7565 2.07118 11.2198 2.04149 11.6772 2.04149C12.173 2.04149 12.6695 2.07611 13.1584 2.14364V2.35487C13.1584 2.71517 13.3045 3.06736 13.5586 3.32049L14.5643 4.3262C14.8858 4.64768 14.4468 4.95539 14.3088 5.23005C12.9143 6.46569 11.3282 7.97521 9.48819 9.81519C8.77872 10.5246 8.11882 11.196 7.50427 11.8336V11.4941C7.50427 11.1368 7.36521 10.8015 7.1134 10.5507L4.5598 7.99649C4.49261 7.92955 4.4556 7.84 4.4556 7.7443V4.84782C5.06248 4.29236 5.73201 3.80642 6.45017 3.40354C6.68537 3.27161 6.76906 2.974 6.63713 2.7388C6.5052 2.5036 6.20754 2.41991 5.97239 2.55184C2.55985 4.46628 0.00898434 8.29757 0.00898434 12.2838C0.00302733 12.44 0 12.5942 0 12.7421C0 14.8946 0.578757 16.9581 1.66225 18.7553C1.09941 19.618 0.710837 20.3685 0.485057 21.0286C0.0935543 22.1733 0.199853 23.0585 0.800876 23.6595C1.77787 24.6365 3.18339 24.2806 4.25658 23.6844C4.49232 23.5535 4.57723 23.2562 4.44627 23.0205C4.31531 22.7847 4.0181 22.6997 3.78231 22.8307C3.11351 23.2023 2.13007 23.6076 1.4914 22.969C0.972848 22.4504 1.24697 21.2907 2.25658 19.6452C2.60668 20.1209 2.99481 20.5736 3.42025 20.9991C5.62581 23.2046 8.55822 24.4193 11.6772 24.4193C16.4046 24.4193 20.7806 21.4545 22.53 17.0613C23.076 15.6901 23.355 14.2178 23.355 12.7421C23.355 8.97173 21.477 5.36037 18.395 3.19134C20.5315 1.69549 22.0313 1.20731 22.6421 1.8183C22.9703 2.14642 23.0588 2.6116 22.9048 3.20267C22.904 3.20603 22.8402 3.45242 22.7491 3.71541L22.2666 3.00457C22.115 2.78148 21.8115 2.72337 21.5883 2.87483C21.3652 3.0263 21.3071 3.32996 21.4586 3.55305L22.4423 5.00197C22.5774 5.20153 22.8495 5.27199 23.0648 5.16433L24.7302 4.33054C24.9713 4.20984 25.0689 3.91648 24.9482 3.67537V3.67537ZM17.9777 4.09304C18.6672 4.59558 19.2987 5.18132 19.8493 5.83317C21.4802 7.76007 22.3785 10.2137 22.3785 12.7421C22.3785 13.2714 22.3392 13.8006 22.2617 14.3241C22.1905 14.3085 22.1236 14.2728 22.0694 14.2183L20.9008 13.0498C20.6427 12.7918 20.2998 12.6497 19.9353 12.6497H18.7766C18.5619 12.6497 18.3874 12.4754 18.3874 12.2611V11.0538C18.3874 10.694 18.2418 10.342 17.9879 10.0882L15.2543 7.35392C15.1822 7.28204 15.1408 7.18204 15.1408 7.07951V5.84191C15.1408 5.82619 15.1421 5.81061 15.144 5.79509C16.0233 5.02214 16.8229 4.36287 17.5589 3.80325C17.7006 3.89666 17.8405 3.99299 17.9777 4.09304V4.09304ZM15.2549 3.63557L14.2485 2.62923C14.1764 2.55736 14.1351 2.45736 14.1351 2.35482C14.1328 2.34627 14.1351 2.33455 14.1351 2.32562C15.0101 2.53162 15.8577 2.84959 16.6532 3.26829C16.3075 3.53767 15.9486 3.82747 15.5749 4.13928C15.5078 3.95193 15.3996 3.7803 15.2549 3.63557V3.63557ZM7.86266 14.3212H10.4408C10.6381 14.3212 10.7986 14.4817 10.7986 14.6789V18.0051C10.7986 18.0991 10.7604 18.1913 10.6937 18.258L6.79533 22.1564C6.72405 22.2277 6.60095 22.1761 6.60095 22.0755V18.2487C6.60095 17.8919 6.46233 17.5569 6.21057 17.3052L4.96058 16.0557C5.53216 15.3876 6.17307 14.6719 6.89089 13.9001C7.13454 14.159 7.4799 14.3212 7.86266 14.3212V14.3212ZM6.42356 11.2418C6.49075 11.3087 6.52776 11.3983 6.52776 11.494V12.8591C5.8346 13.5966 5.20745 14.2858 4.64129 14.9328V13.1484C4.64129 12.4127 4.04246 11.8141 3.30638 11.8141H1.0165C1.2017 9.63321 2.06996 7.53878 3.47909 5.86467V7.7442C3.47909 8.10147 3.61815 8.43678 3.86996 8.68756L6.42356 11.2418ZM0.977145 12.7907H3.30633C3.50394 12.7907 3.66468 12.9512 3.66468 13.1485V15.5879C3.66468 15.7304 3.68719 15.8694 3.72982 16.0011C3.22884 16.6047 2.785 17.1701 2.3935 17.7031C2.35375 17.7572 2.31557 17.8103 2.27699 17.8636C1.43569 16.3245 0.985103 14.5924 0.977145 12.7907V12.7907ZM2.83222 18.7684C2.94296 18.6094 3.05868 18.4472 3.1806 18.2812C3.52152 17.817 3.90394 17.3268 4.3307 16.8069L5.52014 17.9958C5.58733 18.063 5.62434 18.1528 5.62434 18.2486V21.5689C5.08802 21.1994 4.58113 20.7789 4.11073 20.3085C3.6326 19.8304 3.20599 19.3146 2.83222 18.7684V18.7684ZM7.6652 22.6676L11.3843 18.9485C11.6327 18.7001 11.7751 18.3562 11.7751 18.0051V14.6789C11.7751 13.9432 11.1766 13.3446 10.4408 13.3446H7.86266C7.7381 13.3446 7.62824 13.2807 7.56403 13.1839C8.34977 12.3556 9.21827 11.4661 10.1788 10.5056C11.6654 9.0189 12.9826 7.75187 14.1643 6.6734V7.07951C14.1643 7.43981 14.3103 7.792 14.5643 8.04508L17.2973 10.7787C17.3695 10.8508 17.4108 10.951 17.4108 11.0538V12.2611C17.4108 13.0139 18.0235 13.6263 18.7766 13.6263H19.9353C20.0376 13.6263 20.1378 13.6679 20.2103 13.7404L21.3785 14.9085C21.5739 15.1044 21.8165 15.2314 22.0742 15.2834C21.9399 15.8351 21.7611 16.3757 21.5401 16.8994C21.4581 16.8872 21.3753 16.8804 21.2925 16.8804H18.9622C18.5074 16.8804 18.0799 17.0574 17.7586 17.3786L17.0816 18.0557C16.4251 18.7121 16.4271 19.8044 17.0816 20.4623L17.9966 21.3774C16.1723 22.7125 13.9493 23.4427 11.6772 23.4427C10.2796 23.4427 8.92316 23.1759 7.6652 22.6676V22.6676ZM20.9586 18.0711C20.5003 18.8651 19.94 19.598 19.2983 20.2525C19.1255 20.4286 18.9459 20.5974 18.7611 20.7609L17.773 19.7728C17.4948 19.4933 17.492 19.0263 17.772 18.7463L18.449 18.0693C18.584 17.9344 18.771 17.8571 18.9622 17.8571H21.0783C21.0391 17.9287 20.9994 18.0003 20.9586 18.0711V18.0711Z"
          fill="#333333"
        />
        <path
          d="M7.75398 2.28932C7.85628 2.53488 8.14549 2.65544 8.39168 2.55348C8.63733 2.45178 8.7575 2.1613 8.65584 1.91579C8.55403 1.66989 8.26389 1.55016 8.01814 1.65163C7.77254 1.75304 7.65169 2.04377 7.75398 2.28932V2.28932Z"
          fill="#333333"
        />
      </svg>
      <p>Global Overrides</p>
    </CanopyHeaderWrap>
  );
};

const Imported_Image_Header = () => {
  return (
    <CanopyHeaderWrap>
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path
            d="M18.1802 25C18.0052 25 17.826 24.9781 17.649 24.9312L1.54166 20.6177C0.437496 20.3135 -0.220838 19.1698 0.0687455 18.0656L2.10104 10.4906C2.17604 10.2125 2.46145 10.051 2.73854 10.1219C3.01666 10.1958 3.18125 10.4823 3.10729 10.7594L1.07604 18.3323C0.931246 18.8844 1.2625 19.4594 1.81562 19.6125L17.9167 23.9239C18.4698 24.0698 19.0406 23.7406 19.1844 23.1906L19.9979 20.176C20.0729 19.8979 20.3583 19.7323 20.6365 19.8083C20.9146 19.8833 21.0781 20.1698 21.0042 20.4469L20.1917 23.4573C19.9469 24.3844 19.1031 25 18.1802 25V25Z"
            fill="#333333"
          />
          <path
            d="M22.9166 18.75H6.24996C5.101 18.75 4.16663 17.8157 4.16663 16.6667V4.16671C4.16663 3.01775 5.101 2.08337 6.24996 2.08337H22.9166C24.0656 2.08337 25 3.01775 25 4.16671V16.6667C25 17.8157 24.0656 18.75 22.9166 18.75ZM6.24996 3.12504C5.676 3.12504 5.20829 3.59275 5.20829 4.16671V16.6667C5.20829 17.2407 5.676 17.7084 6.24996 17.7084H22.9166C23.4906 17.7084 23.9583 17.2407 23.9583 16.6667V4.16671C23.9583 3.59275 23.4906 3.12504 22.9166 3.12504H6.24996Z"
            fill="#333333"
          />
          <path
            d="M9.37496 9.37503C8.226 9.37503 7.29163 8.44066 7.29163 7.2917C7.29163 6.14275 8.226 5.20837 9.37496 5.20837C10.5239 5.20837 11.4583 6.14275 11.4583 7.2917C11.4583 8.44066 10.5239 9.37503 9.37496 9.37503ZM9.37496 6.25004C8.801 6.25004 8.33329 6.71775 8.33329 7.2917C8.33329 7.86566 8.801 8.33337 9.37496 8.33337C9.94891 8.33337 10.4166 7.86566 10.4166 7.2917C10.4166 6.71775 9.94891 6.25004 9.37496 6.25004Z"
            fill="#333333"
          />
          <path
            d="M4.76047 17.6354C4.62714 17.6354 4.49381 17.5844 4.39172 17.4834C4.1886 17.2802 4.1886 16.95 4.39172 16.7469L9.31151 11.8271C9.90109 11.2375 10.9313 11.2375 11.5209 11.8271L12.9855 13.2917L17.0396 8.42712C17.3344 8.074 17.7677 7.86879 18.2292 7.86462H18.2407C18.6969 7.86462 19.1292 8.06254 19.4271 8.40941L24.875 14.7657C25.0625 14.9834 25.0375 15.3125 24.8188 15.5C24.6011 15.6875 24.2729 15.6636 24.0844 15.4438L18.6365 9.08754C18.5355 8.97087 18.3959 8.90629 18.2407 8.90629C18.1323 8.89691 17.9417 8.97191 17.8407 9.09379L13.4209 14.3969C13.3271 14.5094 13.1907 14.5771 13.0438 14.5834C12.8959 14.5938 12.7553 14.5354 12.6521 14.4313L10.7844 12.5636C10.5875 12.3677 10.2448 12.3677 10.048 12.5636L5.12818 17.4834C5.02714 17.5844 4.89381 17.6354 4.76047 17.6354V17.6354Z"
            fill="#333333"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="25" height="25" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <p>Imported Images</p>
    </CanopyHeaderWrap>
  );
};

const CanopyControlPanel = ({ copyRectangle, stopEditing, updateFromInputs, removeImageLayer, handleCanopyZoomExtents, setImageToolbarPosition }) => {
  const carport = useSelector((state) => state.carport);

  const dispatch = useDispatch();

  // refs
  const toolPanel = useRef(null);

  // state
  const [panelScrollPosition, setPanelScrollPosition] = useState(0);

  const getScrollPosition = () => {
    setPanelScrollPosition(toolPanel.current.scrollTop);
  };

  const applyGlobalOverrides = (global_var, global_value) => {
    dispatch(carportActions.applyGlobalOverride(global_var, global_value));
  };

  const runSimulation = () => {
    // convert to swm inputs
    // let swm_inputs = convert_to_swm_canopy(carport.rectangles);

    let center = carport.center;
    if (center == undefined) {
      let features = [];
      Object.values(carport.rectangles).forEach((rect) => features.push(rect.geoJson));
      var featCollection = {
        type: "FeatureCollection",
        features: features,
      };
      let centeroid = turf.getCoords(turf.centroid(featCollection));
      dispatch(carportActions.getCounty(centeroid[1], centeroid[0]));
      center = [centeroid[1], centeroid[0]];
    }
    let new_canopies = {};
    Object.values(carport.rectangles).map((rect) => {
      new_canopies[rect.id] = {
        ...rect,
        editCellsGeoJson: carport.visual[rect.id].modules,
      };
    });

    let swm_inputs = convert_to_swm_canopy(new_canopies, center);
		// console.log(swm_inputs)
    // return
    // init run in the backend
    dispatch(carportActions.initResults(swm_inputs));
  };

  const globalModulesOverlay = () => (
    <Menu
      style={{ height: "300px", overflowY: "auto" }}
      onClick={(e) => {
        // async await as checkProductAndModuleSelect would run before the store was updated and the check within said function would fail
        dispatch(carportActions.setGlobalOverrideInputs("selectGlobalModule", parseInt(e.key)));
      }}
    >
      {Object.values(carport.modules).map((module, index) => (
        <Menu.Item key={index} eventKey={index}>
          {module.name}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <CanopyControlPanelWrapper panelScrollPosition={panelScrollPosition}>
      <div className="project-manager-box">
        <ProjectManager mode="canopy" stopEditing={stopEditing} handleCanopyZoomExtents={handleCanopyZoomExtents} />
      </div>

      <section className="canopy-input-panels" ref={toolPanel} onScroll={getScrollPosition}>
        <Collapse expandIconPosition="right" defaultActiveKey={[]}>
          <Collapse.Panel className="custom-input-panel-header" header={<Module_Header />} key="0">
            <InputHeader mode="carport" updateFromInputs={updateFromInputs} />
            <ModuleInputs mode="carport" updateFromInputs={updateFromInputs} />
          </Collapse.Panel>

          {Object.values(carport.rectangles).length > 0 && (
            <Fragment>
              <Collapse.Panel className="canopy-input-panel-header-list" header={<Canopies_Header />} key="1">
                <Menu className="canopy-menu" selectedKeys={[`${carport.selectedRectId}`]}>
                  {carport.rectangles &&
                    Object.values(carport.rectangles)
                      .sort((a, b) => a.index - b.index)
                      .map((rectangle, index) => (
                        <Menu.Item className="canopy-menu-item" key={rectangle.id} eventKey={rectangle.id}>
                          <div className="canopy-menu-item-name" onClick={() => dispatch(carportActions.selectRectangle(rectangle.id))}>
                            <img src={solIcon} alt="" />
                            {rectangle.name}
                          </div>
                          {rectangle.id == carport.selectedRectId && (
                            <div className="canopy-menu-item-buttons">
                              <Tooltip title="Copy">
                                <Button
                                  type="link"
                                  onClick={() => {
                                    dispatch(carportActions.copyRectangle(rectangle.id));
                                    message.info("Click map to paste Canopy", 5);
                                  }}
                                >
                                  <img src={copy} />
                                </Button>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <Popconfirm
                                  placement="right"
                                  title={`Delete ${carport.rectangles[carport.selectedRectId].name}`}
                                  onCancel={() => console.log("canceled")}
                                  okText="Yes"
                                  cancelText="No"
                                  onConfirm={(e) => {
                                    if (e.originalEvent) e.originalEvent.view.L.DomEvent.stopPropagation(e);
                                    if (e.nativeEvent) e.nativeEvent.view.L.DomEvent.stopPropagation(e);
                                    dispatch(carportActions.deleteRectangle(carport.selectedRectId));
                                  }}
                                >
                                  <Button type="link">
                                    <img src={trashCanBlack} />
                                  </Button>
                                </Popconfirm>
                              </Tooltip>
                            </div>
                          )}
                        </Menu.Item>
                      ))}
                </Menu>
              </Collapse.Panel>
              <Collapse.Panel className="canopy-input-panel-header" header={<Canopy_Inputs_Header />} key="2">
                {carport.rectangles[carport.selectedRectId] ? (
                  <section className="canopy-inputs-accordian">
                    <CanopyInputs />

                    {/* <div className="canopy-title">
                      <Typography.Text
                        strong
                        editable={{
                          onChange: (newCanopyName) => {
                            if (newCanopyName != carport.rectangles[carport.selectedRectId].name && newCanopyName != "") {
                              setCanopyName(newCanopyName);
                              dispatch(carportActions.saveRectangleName(newCanopyName));
                            }
                          },
                        }}
                      >
                        {canopyName}
                      </Typography.Text>
                      <div className="copy-delete">
                        <Tooltip title="Copy">
                          <Button
                            type="link"
                            onClick={() => {
                              copyRectangle("Click map to paste Canopy");
                              dispatch(carportActions.setActiveTool("pasteFromRectanglePanel"));
                            }}
                          >
                            <img src={copy} />
                          </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <Popconfirm
                            placement="right"
                            title={`Delete ${carport.rectangles[carport.selectedRectId].name}`}
                            onCancel={() => console.log("canceled")}
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => {
                              stopEditing(carport.selectedRectId);
                              dispatch(carportActions.deleteRectangle(carport.selectedRectId));
                            }}
                          >
                            <Button type="link">
                              <img src={trashCanBlack} />
                            </Button>
                          </Popconfirm>
                        </Tooltip>
                      </div>
                    </div>
                    <div className="canopy-prodMod-select">

                      <Dropdown overlay={moduleOverlay} placement="bottomCenter" trigger={["click"]}>
                        <Button style={{ width: "200px" }}>
                          {carport.selectedRectId && carport.rectangles[carport.selectedRectId].module.name ? `${carport.rectangles[carport.selectedRectId].module.name}` : "No Canopies Created"}
                          <DownOutlined />
                        </Button>
                      </Dropdown>
                    </div>
                    <div className="canopy-inputs-radios">
                      <Radio.Group
                        value={carport.selectedRectId && carport.rectangles[carport.selectedRectId].orientation}
                        onChange={(e) => updateFromInputs("changeModuleOrientation", e.target.value)}
                      >
                        <Radio value={1}>Portrait</Radio>
                        <Radio value={2}>Landscape</Radio>
                      </Radio.Group>
                    </div>
                    <div className="canopy-input">
                      <label>Modules, Width:</label>
                      <Input
                        size="small"
                        value={dimYValue}
                        type="number"
                        step={1}
                        min={0}
                        suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>mod</span>}
                        max="999"
                        onChange={(e) => {
                          let inputValue = parseInt(e.target.value);
                          setDimYValue(inputValue);
                          updateFromInputs("updateDimension", {
                            xDim: carport.rectangles[carport.selectedRectId].dimensions.modX,
                            yDim:
                              inputValue == 0 || inputValue == null || inputValue < carport.rectangles[carport.selectedRectId].base_dimension.modY
                                ? carport.rectangles[carport.selectedRectId].base_dimension.modY
                                : inputValue,
                          });
                        }}
                      ></Input>
                    </div>
                    <div className="canopy-input">
                      <label>Modules, Length:</label>
                      <Input
                        size="small"
                        value={dimXValue}
                        type="number"
                        step={1}
                        min={0}
                        suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>mod</span>}
                        max="999"
                        onChange={(e) => {
                          let inputValue = parseInt(e.target.value);
                          setDimXValue(inputValue);
                          updateFromInputs("updateDimension", {
                            xDim:
                              inputValue == 0 || inputValue == null || inputValue < carport.rectangles[carport.selectedRectId].base_dimension.modX
                                ? carport.rectangles[carport.selectedRectId].base_dimension.modX
                                : inputValue,
                            yDim: carport.rectangles[carport.selectedRectId].dimensions.modY,
                          });
                        }}
                      ></Input>
                    </div>
                    <div className="canopy-input">
                      <label>Module Height:</label>
                      <Input
                        size="small"
                        value={moduleYValue}
                        type="number"
                        step={0.1}
                        min={0}
                        suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>m</span>}
                        max="999"
                        onChange={(e) => {
                          let inputValue = parseFloat(e.target.value);
                          setModuleYValue(inputValue);
                          updateFromInputs("updateModuleDimension", {
                            x: carport.rectangles[carport.selectedRectId].module_dimensions.x,
                            y: carport.rectangles[carport.selectedRectId].module_dimensions.y,
                            mlm_Width: carport.rectangles[carport.selectedRectId].module_dimensions.mlm_Width,
                            mlm_Length: inputValue,
                          });
                        }}
                      ></Input>
                    </div>
                    <div className="canopy-input">
                      <label>Module Width:</label>
                      <Input
                        size="small"
                        value={moduleXValue}
                        type="number"
                        step={0.1}
                        min={0}
                        suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>m</span>}
                        max="999"
                        onChange={(e) => {
                          let inputValue = parseFloat(e.target.value);
                          setModuleXValue(inputValue);
                          updateFromInputs("updateModuleDimension", {
                            x: carport.rectangles[carport.selectedRectId].module_dimensions.x,
                            y: carport.rectangles[carport.selectedRectId].module_dimensions.y,
                            mlm_Width: inputValue,
                            mlm_Length: carport.rectangles[carport.selectedRectId].module_dimensions.mlm_Length,
                          });
                        }}
                      ></Input>
                    </div>
                    <div className="canopy-input">
                      <label>Modules, Gap:</label>
                      <Input
                        size="small"
                        value={modXGap}
                        type="number"
                        step={0.1}
                        min={0}
                        suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>m</span>}
                        max="359"
                        onChange={(e) => {
                          setModXGap(parseFloat(e.target.value));
                          updateFromInputs("modGap", parseFloat(e.target.value));
                        }}
                      ></Input>
                    </div>
                    <div className="canopy-dimensions">
                      <p>
                        {`Width: ${parseFloat(
                          carport.rectangles[carport.selectedRectId].dimensions.x * 3.281 // meters -> feet
                        ).toFixed(1)} ft`}
                      </p>
                      <p>
                        {`Length: ${parseFloat(
                          carport.rectangles[carport.selectedRectId].dimensions.y * 3.281 // meters -> feet
                        ).toFixed(1)} ft`}
                      </p>
                    </div>
                    <div className="canopy-input">
                      <label>Azimuth:</label>
                      <Input
                        size="small"
                        value={azimuth}
                        type="number"
                        step={1}
                        min="0"
                        max="359"
                        suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>°</span>}
                        onChange={(e) => {
                          setAzimuth(e.target.value);
                          updateFromInputs("updateAzimuth", {
                            azimuth: e.target.value,
                          });
                        }}
                      ></Input>
                    </div> */}
                    {/* <div className="canopy-inputs-radios">
                      <Radio.Group
                        style={{ display: "flex", justifyContent: "space-around" }}
                        value={carport.selectedRectId ? carport.rectangles[carport.selectedRectId].planeType : "single_slope"}
                        onChange={(e) => updateFromInputs("changePlaneType", e.target.value)}
                      >
                        <Radio
                          style={{
                            display: "flex",
                            flexDirection: "column-reverse",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          value={"single_slope"}
                        >
                          <Tooltip title="Single Slope">
                            <img src={singleSlope} alt="Single Slope" />
                          </Tooltip>
                        </Radio>
                        <Radio
                          style={{
                            display: "flex",
                            flexDirection: "column-reverse",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          value={"inverted"}
                        >
                          <Tooltip title="Inverted">
                            <img src={inverted} alt="inverted" />
                          </Tooltip>
                        </Radio>
                        <Radio
                          style={{
                            display: "flex",
                            flexDirection: "column-reverse",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          value={"dual_tilt"}
                        >
                          <Tooltip title="Dual Tilt">
                            <img src={dual_tilt} alt="dual_tilt" />
                          </Tooltip>
                        </Radio>
                      </Radio.Group>
                    </div>
                    {carport.selectedRectId && carport.rectangles[carport.selectedRectId].planeType == "inverted" ? null : (
                      <div className="canopy-input">
                        <label>Tilt:</label>
                        <Input
                          size="small"
                          value={canopyTilt}
                          type="number"
                          min="0"
                          max="15"
                          suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>°</span>}
                          onChange={(e) => {
                            setCanopyTilt(e.target.value);
                            updateFromInputs("changeTilt", parseInt(e.target.value));
                          }}
                        />
                      </div>
                    )}
                    {(carport.rectangles[carport.selectedRectId].planeType == "single_slope" || carport.rectangles[carport.selectedRectId].planeType == "dual_tilt") &&
                      carport.rectangles[carport.selectedRectId].tilt > 7 && (
                        <div className="canopy-warning-text">
                          <Typography.Text type="danger">Tilt has exceeded 7°</Typography.Text>
                        </div>
                      )}
                    {carport.selectedRectId && carport.rectangles[carport.selectedRectId].planeType == "dual_tilt" && (
                      <div className="canopy-warning-text">
                        <Typography.Text>{`Towards Azimuth (Black)`}</Typography.Text>
                        <br />
                        <Typography.Text>{`Away From Azimuth (White)`}</Typography.Text>
                      </div>
                    )}
                    {carport.selectedRectId && carport.rectangles[carport.selectedRectId].planeType == "inverted" && (
                      <Fragment>
                        <div className="canopy-input">
                          <label>Toward Azimuth:</label>
                          <Input
                            size="small"
                            value={tiltTowardAzi}
                            type="number"
                            min="0"
                            max={carport.rectangles[carport.selectedRectId].dimensions.modY}
                            suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>mod</span>}
                            onChange={(e) => {
                              setTiltTowardAzi(e.target.value);
                              updateFromInputs("changeTowardAzimuth", parseInt(e.target.value));
                            }}
                          />
                        </div>
                        <div className="canopy-warning-text">
                          <label>{`Away from Azimuth(White): ${carport.rectangles[carport.selectedRectId].dimensions.modY - carport.rectangles[carport.selectedRectId].towardAzimuth}`}</label>
                        </div>
                        <div className="canopy-input">
                          <label>Tilt to Azimuth:</label>
                          <Input
                            size="small"
                            value={tiltToAzi}
                            type="number"
                            min="0"
                            max="25"
                            suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>°</span>}
                            onChange={(e) => {
                              setTiltToAzi(e.target.value);
                              updateFromInputs("changeTiltToAzimuth", parseInt(e.target.value));
                            }}
                          />
                        </div>
                        <div className="canopy-input">
                          <label>Tilt from Azimuth:</label>
                          <Input
                            size="small"
                            value={tiltFromAzi}
                            type="number"
                            min="0"
                            max="25"
                            suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>°</span>}
                            onChange={(e) => {
                              setTiltFromAzi(e.target.value);
                              updateFromInputs("changeTiltFromAzimuth", parseInt(e.target.value));
                            }}
                          />
                        </div>
                      </Fragment>
                    )} */}
                  </section>
                ) : (
                  <div className="canopy-inputs-empty-box">
                    <Empty description="Please Select a Canopy" />
                  </div>
                )}
              </Collapse.Panel>

              <Collapse.Panel className="canopy-input-panel-header" header={<Global_Overrides_Header />} key="3">
                <div className="global-overrides">
                  <div className="global-override-input">
                    <label>Module: </label>
                    <div className="global-dropdown">
                      <Dropdown overlay={globalModulesOverlay} trigger={["click"]}>
                        <Button>
                          {carport.globalOverrides.module.moduleIndex == -1 ? "Select Module" : carport.globalOverrides.module.globalModule.name} <DownOutlined />
                        </Button>
                      </Dropdown>
                    </div>
                    <div className="global-set-button">
                      <Button type="primary" onClick={(e) => applyGlobalOverrides("setGlobalModule", carport.globalOverrides.module)}>
                        Set All
                      </Button>
                    </div>
                  </div>
                  <div className="global-override-input">
                    <label>Orientation:</label>
                    <div className="global-radio-buttons">
                      <Radio.Group
                        style={{ display: "flex", alignItems: "center" }}
                        value={carport.globalOverrides.orientation}
                        onChange={(e) => dispatch(carportActions.setGlobalOverrideInputs("orientation", parseInt(e.target.value)))}
                      >
                        <Radio value={1}>Portrait</Radio>
                        <Radio value={2}>Landscape</Radio>
                      </Radio.Group>
                    </div>
                    <div className="global-set-button">
                      <Button type="primary" onClick={(e) => applyGlobalOverrides("setGlobalOrientation", parseInt(carport.globalOverrides.orientation))}>
                        Set All
                      </Button>
                    </div>
                  </div>
                  <div className="global-override-input">
                    <label>Azimuth:</label>
                    <div className="input-wrapper">
                      <Input
                        size="small"
                        defaultValue={carport.globalOverrides.azimuth || 180}
                        type="number"
                        min="0"
                        max="359"
                        suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>°</span>}
                        onPressEnter={() => applyGlobalOverrides("setGlobalAzimuth", carport.globalOverrides.azimuth)}
                        onChange={(e) => {
                          e.target.value && e.target.value < 359 && e.target.value >= 0 && dispatch(carportActions.setGlobalOverrideInputs("azimuth", parseInt(e.target.value)));
                        }}
                      />
                    </div>
                    <div className="global-set-button">
                      <Button type="primary" onClick={() => applyGlobalOverrides("setGlobalAzimuth", carport.globalOverrides.azimuth)}>
                        Set All
                      </Button>
                    </div>
                  </div>
                  <div className="global-override-input">
                    <label>Tilt:</label>
                    <div className="input-wrapper">
                      <Input
                        size="small"
                        defaultValue={carport.globalOverrides.tilt || 7}
                        type="number"
                        min="0"
                        max="359"
                        suffix={<span style={{ color: "rgba(0,0,0,.45)", fontSize: "x-small" }}>°</span>}
                        onPressEnter={() => applyGlobalOverrides("setGlobalTilt", carport.globalOverrides.tilt)}
                        onChange={(e) => {
                          e.target.value && e.target.value < 15 && e.target.value >= 0 && dispatch(carportActions.setGlobalOverrideInputs("tilt", parseInt(e.target.value)));
                        }}
                      />
                    </div>
                    <div className="global-set-button">
                      <Button type="primary" onClick={() => applyGlobalOverrides("setGlobalTilt", carport.globalOverrides.tilt)}>
                        Set All
                      </Button>
                    </div>
                  </div>
                  <div className="global-override-input">
                    <label>Plane Type:</label>
                    <div className="global-radio-buttons ">
                      <Radio.Group
                        style={{ display: "flex", width: "100%" }}
                        value={carport.globalOverrides.planeType}
                        onChange={(e) => dispatch(carportActions.setGlobalOverrideInputs("setGlobalPlaneType", e.target.value))}
                      >
                        <Radio
                          style={{
                            display: "flex",
                            flexDirection: "column-reverse",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          value={"single_slope"}
                        >
                          <Tooltip title="Single Slope">
                            <img src={singleSlope} alt="Single Slope" />
                          </Tooltip>
                        </Radio>
                        <Radio style={{ display: "flex", flexDirection: "column-reverse", justifyContent: "center", alignItems: "center" }} value={"inverted"}>
                          <Tooltip title="Inverted">
                            <img src={inverted} alt="inverted" />
                          </Tooltip>
                        </Radio>
                        <Radio style={{ display: "flex", flexDirection: "column-reverse", justifyContent: "center", alignItems: "center" }} value={"dual_tilt"}>
                          <Tooltip title="Dual Tilt">
                            <img src={dual_tilt} alt="dual_tilt" />
                          </Tooltip>
                        </Radio>
                      </Radio.Group>
                    </div>
                    <div className="global-set-button">
                      <Button type="primary" onClick={(e) => applyGlobalOverrides("setGlobalPlaneType", carport.globalOverrides.planeType)}>
                        Set All
                      </Button>
                    </div>
                  </div>
                </div>
              </Collapse.Panel>

              {Object.values(carport.images).length > 0 && (
                <Collapse.Panel className="canopy-input-panel-header-list" header={<Imported_Image_Header />} key="4">
                  <Menu
                    className="canopy-menu"
                    onClick={(eventKey) => {
                      dispatch(carportActions.selectImage(eventKey.key));
                      setImageToolbarPosition(carport.images[eventKey.key].corners);
                    }}
                    selectedKeys={[`${carport.selectedImageId}`]}
                  >
                    {carport.images &&
                      Object.keys(carport.images).map((key) => (
                        <Menu.Item className="canopy-menu-item" id={`image_${key}`} key={key}>
                          <div className="canopy-image-item">
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clipPath="url(#clip0)">
                                <path
                                  d="M22.9167 3.75H2.08333C0.933333 3.75135 0.00135417 4.68333 0 5.83333V19.1667C0.00135417 20.3167 0.933333 21.2486 2.08333 21.25H22.9167C23.0336 21.2505 23.1503 21.2403 23.2654 21.2196C24.268 21.0518 25.0019 20.1832 25 19.1667V5.83333C24.9986 4.68328 24.0667 3.75135 22.9167 3.75ZM2.08333 20.4167C1.43568 20.4166 0.895313 19.9218 0.838333 19.2767L9.14583 13.845L17.5942 20.4167H2.08333ZM24.1667 19.1667C24.1673 19.7782 23.7244 20.3001 23.1208 20.3987C23.0534 20.4109 22.9851 20.4169 22.9167 20.4167H18.9513L13.4308 16.1204L18.3675 12.1729L24.1667 15.6525V19.1667ZM24.1667 14.6808L18.5479 11.3096C18.3985 11.2197 18.2091 11.2324 18.0729 11.3412L12.7533 15.5954L9.42208 13.0046C9.28172 12.8955 9.08766 12.8874 8.93875 12.9846L0.833333 18.2842V5.83333C0.833333 5.14297 1.39297 4.58333 2.08333 4.58333H22.9167C23.607 4.58333 24.1667 5.14297 24.1667 5.83333V14.6808Z"
                                  fill="#333333"
                                />
                                <path
                                  d="M12.5 6.25C11.1193 6.25 10 7.36927 10 8.75C10.0014 10.1302 11.1198 11.2486 12.5 11.25C13.8807 11.25 15 10.1307 15 8.75C15 7.36927 13.8807 6.25 12.5 6.25ZM12.5 10.4167C11.5795 10.4167 10.8333 9.67047 10.8333 8.75C10.8333 7.82953 11.5795 7.08333 12.5 7.08333C13.4205 7.08333 14.1667 7.82953 14.1667 8.75C14.1667 9.67047 13.4205 10.4167 12.5 10.4167Z"
                                  fill="#333333"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0">
                                  <rect width="25" height="25" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                            <p>{carport.images[key].name}</p>
                          </div>
                          {key == carport.selectedImageId && (
                            <div className="canopy-menu-item-buttons">
                              <Tooltip title="Delete Image">
                                <Popconfirm
                                  key={key}
                                  id={key}
                                  placement="right"
                                  title={"Delete this image?"}
                                  onCancel={() => console.log("canceled")}
                                  okText="Yes"
                                  cancelText="No"
                                  onConfirm={() => {
                                    let id = carport.selectedImageId;
                                    console.log("selectedImageid", id);
                                    dispatch(carportActions.setActiveImageEditTool("delete"));
                                    setTimeout(() => {
                                      dispatch(carportActions.deleteImage(id));
                                      removeImageLayer(id);
                                    }, 250);
                                  }}
                                >
                                  <Button type="link" disabled={carport.selectedImageId == undefined}>
                                    <img src={trashCanBlack} />
                                  </Button>
                                </Popconfirm>
                              </Tooltip>
                            </div>
                          )}
                        </Menu.Item>
                      ))}
                  </Menu>
                </Collapse.Panel>
              )}
            </Fragment>
          )}
        </Collapse>

        {Object.values(carport.rectangles).length == 0 && (
          <div className="empty-box">
            <Empty
              description={
                <span style={{ width: "140px", margin: "0 auto", display: "inline-block" }}>
                  Click the <img style={{ height: "20px", width: "20px", margin: "0 6px" }} src={rectWithOffsetVerts} /> icon on the map toolbar to place a canopy.
                </span>
              }
            />
          </div>
        )}
      </section>

      {carport.uiState.inputs_changed_warning && (
        <section className="warning-text">
          <p>*Inputs have changed since last results were generated</p>
        </section>
      )}

      <div className="generate-buttons-container">
        <div className="generate-buttons">
          <Button type="primary" loading={carport.generatingCanopyResults} onClick={() => runSimulation()} disabled={Object.values(carport.rectangles).length <= 0 ? true : false}>
            Generate
          </Button>
          {!carport.hasCanopyResults && (
            <Button type="danger" onClick={() => dispatch(carportActions.cancelRun(carport.run_id))} disabled={!carport.generatingCanopyResults} loading={carport.uiState.canceling}>
              Cancel
            </Button>
          )}

          {carport.hasCanopyResults && (
            <Button type="primary" ghost onClick={() => dispatch(carportActions.setUIState("view_results_table", !carport.uiState.view_results_table))}>
              <span>{carport.uiState.view_results_table ? "Hide" : "View"} Results</span>
            </Button>
          )}
        </div>
      </div>
    </CanopyControlPanelWrapper>
  );
};

export { CanopyControlPanel };
